import { getApiEndpoint } from './config/selectors'
import { getApiToken } from './auth/selectors'

export function apiCapableActionCreator(actionCreator) {
  return (...actionArgs) => ({ getState, dispatch, graphQLClient }) => {
    const state = getState()
    const apiConfig = {
      apiEndpoint: getApiEndpoint(state),
      apiToken: getApiToken(state),
    }
    dispatch(
      actionCreator(...actionArgs)({
        getState,
        dispatch,
        apiConfig,
        graphQLClient,
      })
    )
  }
}
